import classNames from "classnames";
import { SearchIcon } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  setText: any;
  text: any;
  isDisabled?: boolean;
}

export const SearchBar = ({ setText, text, isDisabled }: IProps) => {
  return (
    <div className={classNames("search-bar-wrapper")}>
      <div className="input-field">
        <input
          type="text"
          placeholder="Search"
          onChange={(event: any) => setText(event.target.value)}
          value={text}
          disabled={isDisabled}
        />
      </div>
      <div className="search-icon">
        <SearchIcon />
      </div>
    </div>
  );
};
